// New status values (used in dropdowns)
export enum ProjectVisibility {
  EXTERNE = 'externe',
  INTERNE = 'interne',
}

export const ProjectVisibilityLabels: Record<ProjectVisibility, string> = {
  [ProjectVisibility.EXTERNE]: 'Externe',
  [ProjectVisibility.INTERNE]: 'Interne',
}

export enum ProjectStatus {
  PRE_DEVELOPMENT = 'pre_development',
  IN_DEVELOPMENT = 'in_development',
  MAINTENANCE = 'maintenance',
  DELIVERED = 'delivered',
}

export const ProjectStatusLabels: Record<ProjectStatus, string> = {
  [ProjectStatus.PRE_DEVELOPMENT]: 'Pré Développement',
  [ProjectStatus.IN_DEVELOPMENT]: 'En Développement',
  [ProjectStatus.MAINTENANCE]: 'En Maintenance',
  [ProjectStatus.DELIVERED]: 'Livré',
}

// All status labels (including legacy values for display compatibility)
export const AllProjectStatusLabels: Record<string, string> = {
  // New statuses
  'pre_development': 'Pré Développement',
  'in_development': 'En Développement',
  'maintenance': 'En Maintenance',
  'delivered': 'Livré',
  // Legacy statuses (for existing data display)
  'planning': 'Pré Développement',
  'in_progress': 'En Développement',
  'on_hold': 'En Maintenance',
  'completed': 'Livré',
  'cancelled': 'Annulé',
  'draft': 'Brouillon',
}

export enum BusinessSector {
  TECHNOLOGY = 'technology',
  FINANCE = 'finance',
  HEALTHCARE = 'healthcare',
  RETAIL = 'retail',
  MANUFACTURING = 'manufacturing',
  EDUCATION = 'education',
  MARKETING = 'marketing',
  CONSULTING = 'consulting',
  OTHER = 'other',
}

export const BusinessSectorLabels: Record<BusinessSector, string> = {
  [BusinessSector.TECHNOLOGY]: 'Technologie',
  [BusinessSector.FINANCE]: 'Finance',
  [BusinessSector.HEALTHCARE]: 'Santé',
  [BusinessSector.RETAIL]: 'Commerce de détail',
  [BusinessSector.MANUFACTURING]: 'Fabrication',
  [BusinessSector.EDUCATION]: 'Éducation',
  [BusinessSector.MARKETING]: 'Marketing',
  [BusinessSector.CONSULTING]: 'Conseil',
  [BusinessSector.OTHER]: 'Autre',
}

// Utility function to convert enum to select options
export function enumToSelectOptions<T extends Record<string, string>>(
  enumObject: T,
  labels: Record<T[keyof T], string>
): Array<{ value: string; label: string }> {
  return Object.values(enumObject).map((value) => ({
    value: value,
    label: labels[value as T[keyof T]],
  }));
}

